<script setup> 
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import { ref } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head } from '@inertiajs/inertia-vue3';
import BaseButton from "@/Components/BaseButton.vue";
import { mdiPlusCircle } from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
//import TableAdvancedFilter from "@/Components/TableAdvancedFilter.vue";
import TableAdvanced from "@/Components/TableAdvanced.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';

defineProps({
    files: Array,
    columnas: Array
});

const rutaPrefijo = ref('file');
const modulo = ref('Documento');
const modulos = ref('Documentos');

</script>

<template>

    <Head title="Documentos" />

    <BreezeAuthenticatedLayout>
        <template #header>
        <PremiumPageHeader title="Documentos por nivel educativo" subtitle="Gestión de documentos por nivel educativo">
            <template #buttons>
                <BaseButton :classLabel="'hidden sm:block'" color="info" :icon="mdiPlusCircle" small label=" Nuevo" class="ml-8 inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right" />
                <BaseButton :classLabel="'hidden sm:block'"
                        color="info"
                        :icon="mdiPlusCircle"
                        small
                        label=" Nuevo"
                        class="ml-2 inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
                    />
                <BaseButton :classLabel="'hidden sm:block'"
                        color="info"
                        :icon="mdiPlusCircle"
                        small
                        label=" Registro público"
                        class="inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
                    />
            </template>
        </PremiumPageHeader>
    </template>

        <div>
            <div class="bg-white shadow-lg rounded-md border p-4">

                <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->

                <CardBox class="mb-6" has-table>
                    <!-- Tablesingle opciones: checkable -->
                    <div class="w-full overflow-x-auto relative">
                        <TableAdvanced :modulo="modulo" :modulos="modulos" :data="files" :fields="columnas" deleteable :ruta="rutaPrefijo" />
                    </div>
                </CardBox>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>